import React, { useEffect, useState } from "react"
import { Link, CircularProgress } from "@mui/material"
import { getSubstitutionProductionDays, getSupplierItemRecipes } from "../../api/supplierItemRecipes"
import SupplierItemRecipesDialog from "./SupplierItemRecipesDialog"

// KFC-598: "Toutes" of a substitution on every recipe, replaced by the recipes in production that contain the replaced item
const SubstitutionRecipesCell = ({ substitution }) => {
	const [supplierItemRecipes, setSupplierItemRecipes] = useState(null)
	const [error, setError] = useState(false)
	const [openDialog, setOpenDialog] = useState(false)

	const supplierItemId = substitution.originalSupplierItem?.objectId
	const { startDate, endDate } = getSubstitutionProductionDays(substitution)

	useEffect(() => {
		if (!supplierItemId) return
		let cancelled = false

		const load = async () => {
			try {
				const result = await getSupplierItemRecipes({ supplierItemId, startDate, endDate })
				if (!cancelled) setSupplierItemRecipes(result)
			}
			catch (e) {
				if (!cancelled) setError(true)
			}
		}
		load()

		return () => { cancelled = true }
	}, [supplierItemId, startDate, endDate])

	if (!supplierItemId) return "Toutes"
	if (error) return "Toutes (détail indisponible)"
	if (!supplierItemRecipes) return <CircularProgress size={16} />
	if (supplierItemRecipes.recipesCount === 0) return "Aucune recette en prod"

	const handleOpen = (event) => {
		event.stopPropagation()
		setOpenDialog(true)
	}

	return (
		<>
			<Link component="button" underline="hover" onClick={handleOpen}>
				{supplierItemRecipes.recipesCount} recette{supplierItemRecipes.recipesCount > 1 ? "s" : ""} ›
			</Link>
			<SupplierItemRecipesDialog
				open={openDialog}
				onClose={() => setOpenDialog(false)}
				supplierItem={{ value: supplierItemId, name: substitution.originalSupplierItem.name }}
				startDate={startDate}
				endDate={endDate}
				supplierItemRecipes={supplierItemRecipes}
			/>
		</>
	)
}

export default SubstitutionRecipesCell
